import {useCommunity} from "../Community/CommunityProvider/CommunityProvider";

export const useGetNewsFeedGroupId = () => {
    const {selectedCommunity} = useCommunity();

    return {id: selectedCommunity?.newsFeedGroups?.[0]?.conversationId as string};
};
